import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserAvatarComponent } from '../user-avatar/user-avatar.component';
import { UserNameOrEmailPipe } from '../../pipes/user-name-or-email.pipe';
import { ILecturer } from '../../models/user/lecturer/lecturer.model';
import { IOrgUser, IUser } from '../../models/user/user.model';
import { SelectedOrgService } from '../../services/selected-org.service';
import { ILocket } from '../../models/locket/locket.model';
import { UserHelperService } from '../../services/helpers/user-helper.service';

@Component({
  selector: 'app-lecturer-avatar-name',
  standalone: true,
  imports: [CommonModule, UserAvatarComponent, UserNameOrEmailPipe],
  templateUrl: './lecturer-avatar-name.component.html',
  styleUrls: ['./lecturer-avatar-name.component.scss']
})
export class LecturerAvatarNameComponent implements OnInit {

  @Input({required: true}) lecturer: ILecturer & { user?: IUser & { orgUsers: IOrgUser[]; lockets?: ILocket[] } } | undefined;
  @Input({required: true}) locketOrgId: number | undefined;

  constructor(
    public userHelperService: UserHelperService,
    public selectedOrg: SelectedOrgService,
  ) { }

  ngOnInit(): void {
  }

}
